import { APIADAPTER_FACTORY_EXPOSE_KEY } from '../../client/src/consts';
import { ADAPTER_NAMES } from '../../client/src/modules/_core/types';
import HttpClient from '../http-client';
import AdastraApiAdapter from './AdastraApiAdapter';
/**
 * https://trello.com/c/RH4o09zd/3-chat-orchestration-co-init-uprava-komunikace-chat-bubliny
 */
function buildAdastraApiAdapter(config) {
    return new AdastraApiAdapter(new HttpClient(config.URL));
}
// export the builder into the global scope
window[APIADAPTER_FACTORY_EXPOSE_KEY] = window[APIADAPTER_FACTORY_EXPOSE_KEY] || {};
window[APIADAPTER_FACTORY_EXPOSE_KEY][ADAPTER_NAMES.ADASTRA] = buildAdastraApiAdapter;
export default buildAdastraApiAdapter;
